import { useEffect, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";

type GetAccountLinksResult = {
    hasAdminLinks: boolean,
    linkNames: string[]
}

type AccountLinksResult = [
    GetAccountLinksResult | null,
    boolean,
    string | null
];

const useNavLinks: () => AccountLinksResult = () => {
    const [ result, setResult ] = useState<GetAccountLinksResult | null>(null);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(false);    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {        
        const controller = new AbortController();
        (async () => {            
            console.log('navLinks: ', result)
            if (user && user.id_token) {
                setLoading(true);
                try {
                    const resp = await fetcher("/api/v3.0/accounts/my/nav-links", {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json() as GetAccountLinksResult;
                    setResult(data);
                } catch (err) {
                    //Will be done in BFLY-8658 or BFLY-9022
                } finally {
                    setLoading(false);
                }
            }
        })();
        return () => controller.abort();
    },[ user]);

    return [
        result,
        loading,
        error
    ];
};

export default useNavLinks;